import React from 'react'

const AIPlanner = () => {
  return (
    <div className="bg-white rounded-[25px] px-[18px] xl:px-[23px] py-[15px] xl:py-[18px]">AIPlanner</div>
  )
}

export default AIPlanner